import {YesNoFormValue, type KilnCheckSheetCoolerBaghouseSectionFormValues} from '../../../types'

export const coolerBaghouseSectionDefaultValues: KilnCheckSheetCoolerBaghouseSectionFormValues = {
  baghouseFan5930DamageLeaks: {value: YesNoFormValue.YES, comment: ''},
  screwsDragsElevatorDamageLeaks: {value: YesNoFormValue.YES, comment: ''}
}
